import { createMuiTheme } from "@material-ui/core/styles";

// Font
import LatoLightWoff2 from "./assets/fonts/Lato/Lato-Light/Lato-Light.woff2";
import LatoRegulerWoff2 from "./assets/fonts/Lato/Lato-Regular/Lato-Regular.woff2";
import LatoBoldWoff2 from "./assets/fonts/Lato/Lato-Bold/Lato-Bold.woff2";

const LatoLight = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 100,
  src: `
      local('Lato'),
      local('Lato-Light'),
      url(${LatoLightWoff2}) format('woff2')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

const LatoReguler = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: "normal",
  src: `
      local('Lato'),
      local('Lato-Reguler'),
      url(${LatoRegulerWoff2}) format('woff2')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

const LatoBold = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: "bold",
  src: `
      local('Lato'),
      local('Lato-Bold'),
      url(${LatoBoldWoff2}) format('woff2')
    `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export default createMuiTheme({
  palette: {
    primary: {
        main: '#1F263E'
    },
    secondary: {
        main: "#2196F3",
    },
  },
  typography: {
    fontFamily: "Lato, Arial",
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [LatoLight, LatoReguler, LatoBold],
      },
    },
  },
});
